import {
  FETCH_DATA_START,
  FETCH_DATA_SUCCESS,
  FETCH_SPECIFIC_SURVEY_DATA_SUCCESS,
  FETCH_OWNED_AGENCY_DATA_SUCCESS,
  FETCH_OWNED_AGENCY_DATA_START,
  REMOVE_OWNED_AGENCY_DATA,
  FETCH_DATA_FAIL,
} from '../actions/actionTypes.js';
import { combineCustomAndRegularBatchDataCodes } from '../../helperFunctions';

const SURVEY_COLLECTION_NAMES = {
  Brand: 'brandPersonas',
  Buyer: 'buyerPersonas',
  Social: 'socialPosts',
  brand: 'brandPersonas',
  buyer: 'buyerPersonas',
  social: 'socialPosts',
  Marketing: 'socialPosts',
  marketing: 'socialPosts',
};

const INIT_STATE = {
  brandPersonaSurveyQuestions: null,
  buyerPersonaSurveyQuestions: null,
  socialPostSurveyQuestions: null,
  brandPersonas: null,
  buyerPersonas: null,
  socialPosts: null,
  batchBrands: null,
  ownedAgencyStats: null,
  visibleAgencies: [],
  existingBatchData: null,
  combinedBatchDataCodes: null,
  yourBrandAndConsumersData: null,
  loadingAgencyData: false,
  loading: true,
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_DATA_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        brandPersonaSurveyQuestions: action.brandPersonaSurveyQuestions,
        buyerPersonaSurveyQuestions: action.buyerPersonaSurveyQuestions,
        socialPostSurveyQuestions: action.socialPostSurveyQuestions,
        brandPersonas: action.brandPersonas,
        buyerPersonas: action.buyerPersonas,
        socialPosts: action.socialPosts,
        existingBatchData: action.existingBatchData,
        combinedBatchDataCodes: combineCustomAndRegularBatchDataCodes(action.existingBatchData, action.customBatchData),
        yourBrandAndConsumersData: action.yourBrandAndConsumersData,
        batchBrands: action.batchBrands,
        ownedAgencyStats: action.ownedAgencyStats,
        visibleAgencies: [action.agencyId],
      };
    case FETCH_SPECIFIC_SURVEY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        [SURVEY_COLLECTION_NAMES[action.surveyType]]: action.surveyData,
      };
    case FETCH_OWNED_AGENCY_DATA_SUCCESS:
      return {
        ...state,
        loadingAgencyData: false,
        error: false,
        visibleAgencies: [...state.visibleAgencies, action.agencyId],
        brandPersonas: state.brandPersonas?.concat(action.ownedAgencyData.brandPersonas),
        buyerPersonas: state.buyerPersonas?.concat(action.ownedAgencyData.buyerPersonas),
        socialPosts: state.socialPosts?.concat(action.ownedAgencyData.socialPosts),
      };
    case FETCH_OWNED_AGENCY_DATA_START:
      return {
        ...state,
        loadingAgencyData: true,
        error: false,
      };

    case REMOVE_OWNED_AGENCY_DATA:
      return {
        ...state,
        loadingAgencyData: false,
        error: false,
        visibleAgencies: state.visibleAgencies.filter(e => e !== action.agencyId),
        brandPersonas: state.brandPersonas.filter(e => e.agencyId !== action.agencyId),
        buyerPersonas: state.buyerPersonas.filter(e => e.agencyId !== action.agencyId),
        socialPosts: state.socialPosts.filter(e => e.agencyId !== action.agencyId),
      };
    case FETCH_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};
